"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const User_1 = require("../User");
class NullUserRepository {
    clear() { }
    async clearAsync() { }
    userOfId(userId) { return User_1.User.INVALID_USER; }
    async userOfIdAsync(userId) { return User_1.User.INVALID_USER; }
    userOfName(username) { return User_1.User.INVALID_USER; }
    async userOfNameAsync(username) { return User_1.User.INVALID_USER; }
    async allItemAsync() { return []; }
    exists(username) { return false; }
    save(user) { }
    async saveAsync(user) { }
}
exports.NullUserRepository = NullUserRepository;
//# sourceMappingURL=NullUserRepository.js.map